/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../../../common";
import type {
  Semver,
  SemverInterface,
} from "../../../../@ethereum-attestation-service/eas-contracts/contracts/Semver";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "major",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minor",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "patch",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type SemverConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SemverConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Semver__factory extends ContractFactory {
  constructor(...args: SemverConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    major: BigNumberish,
    minor: BigNumberish,
    patch: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(major, minor, patch, overrides || {});
  }
  override deploy(
    major: BigNumberish,
    minor: BigNumberish,
    patch: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(major, minor, patch, overrides || {}) as Promise<
      Semver & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Semver__factory {
    return super.connect(runner) as Semver__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SemverInterface {
    return new Interface(_abi) as SemverInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Semver {
    return new Contract(address, _abi, runner) as unknown as Semver;
  }
}
